<template>
  <div class="m-footer-comment" @click.stop ref="commentBox" :style="style">
    <textarea
      v-model="content.comTxt"
      placeholder="我来说两句"
      class="fz13 m-footer-comment-textarea"
      id="j-comment-box"
      v-focus
      ref="textarea"
    ></textarea>
    <div class="m-footer-comment-btngrp">
      <button class="c-btn-icons" @click="uploadImage">
        <img :src="icons.photo">
      </button>
      <span class="c-btn-icons" v-if="false">
        <img :src="icons.emotion">
      </span>
      <span class="c-btn-icons" v-if="false">
        <img :src="icons.mention">
      </span>
      <button :class="['c-post', 'fz15', {active: content.comTxt.length > 0 && !imgLoading}]" @click="pub">发布</button>
    </div>
    <div class="m-footer-comment-imgs-preview"  v-if="imgList.length > 0 || imgLoading">
      <ul>
        <li v-for="(item, index) in imgList" class="img-wrapper">
          <img :src="hosts.showimg + item.src">
          <span @click="delImg(index)" class="del fz12">x</span>
        </li>
        <li v-show="imgList.length < 4" :class="['img-wrapper', 'add',{'loading': imgLoading}]" @click="uploadImage">
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import hhkjsq from '@/common/hhkjsq.js'
import {fetch} from '@/utils/index'
import iconPhoto from '@/assets/icons/photo.png'
import iconEmotion from '@/assets/icons/emotion.png'
import iconMention from '@/assets/icons/mention.png'

const {app, hosts, isIPhone} = hhkjsq
export default {
  data () {
    return {
      imgList: [],
      imgLoading: false,
      hosts: hosts,
      isIPhone: isIPhone,
      icons: {
        photo: iconPhoto,
        emotion: iconEmotion,
        mention: iconMention
      }
    }
  },
  directives: {
    focus: {
      inserted: function (el, binding, vnode) {
        el.focus()
      }
    }
  },
  computed: {
    content () {
      return this.$store.state.comment.content
    },
    style () {
      if (isIPhone) {
        return 'position: absolute;top: 0;'
      }
      return 'bottom: 0;'
    }
  },
  methods: {
    pub () {
      if (this.content.comTxt.length <= 0 || this.imgLoading) {
        return
      }
      this.$store.dispatch('handeleImagePath', this.imgList)
      this.$store.dispatch('pubComment')
    },
    uploadImage () {
      if (this.imgLoading) {
        return
      }
      if (this.imgList.length >= 4) {
        return
      }
      this.$store.dispatch('changeImageUploading')
      this.getUploadImageKey().then(key => {
        app.openUpload({
          url: hosts.uploadimg + '/Image/ajax/image_upload_mobile.aspx',
          params: {
            intotype: 2030,
            UploadType: 'Stream',
            key: key
          },
          start: () => {
            this.imgLoading = true
          },
          success: (response) => {
            this.imgList.push(response.img_list[0])
          },
          complete: () => {
            this.imgLoading = false
            this.$store.dispatch('changeImageUploading')
          }
        })
      })
    },

    getUploadImageKey () {
      return fetch({
        url: hosts.uploadimg + '/image/ajax/GetKey.aspx',
        dataType: 'jsonp'
      })()
    },

    delImg (index) {
      this.imgList.splice(index, 1)
    },

    handlefocus () {
      if (isIPhone) {
        let el = this.$refs.textarea
        this.$store.dispatch('focusbottom', el)
      }
    },

    handleblur () {
      if (isIPhone) {
        this.$store.dispatch('blurbottom')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// comment.vue?b5a0c89e